import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, mergeMap, catchError } from 'rxjs/operators';
import * as StateActions from './state-items.actions';
import { SignalRService } from '../../shared/services';
import { SubscriptionType } from '../../shared/models';

@Injectable()
export class StateItemsEffects {
  updateStates = createEffect(() =>
    this.actions$.pipe(
      ofType(StateActions.updateStates),
      mergeMap((action) => {
        return this.signalRService
          .getStateHistory(action.key, { subscriptionType: SubscriptionType.ReplayAll, replaySince: action.date })
          .pipe(
            map((historyItems) => StateActions.updateStatesSuccess({ key: action.fullKey, historyItems })),
            catchError((error) => of(StateActions.loadStateFailure({ key: action.fullKey, error })))
          );
      })
    )
  );

  createState$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StateActions.createState),
      mergeMap((action) => {
        return this.signalRService.getStateHistory(action.key, action.options).pipe(
          map((historyItems) => StateActions.createStateSuccess({ key: action.fullKey, historyItems })),
          catchError((error) => of(StateActions.loadStateFailure({ key: action.fullKey, error })))
        );
      })
    )
  );

  constructor(private actions$: Actions, private signalRService: SignalRService) {}
}
